var _path, _circle, _circle2, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCustomerSatisfactionNordyne(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 59.2766 59.2119",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "Customer Satisfaction") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "CustomerSatisfactionSecondaryNordyne",
    d: "M41.8671,36.0493c-1.9059,5.087-6.7681,8.4576-12.2004,8.4576s-10.2945-3.3706-12.2004-8.4576l-.2349-.6304-2.3115.8653.2349.6304c2.2656,6.0559,8.0523,10.0694,14.5181,10.0694s12.2525-4.0135,14.5181-10.0694l.2349-.6304-2.3115-.8653-.2472.6304Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "CustomerSatisfactionSecondaryNordyne",
    cx: 19.7778,
    cy: 22.2543,
    r: 3.6808
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "CustomerSatisfactionSecondaryNordyne",
    cx: 39.5556,
    cy: 22.2543,
    r: 3.6808
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "CustomerSatisfactionSecondaryNordyne",
    d: "M29.6729.0043C13.3231.0043.0691,13.2584.0691,29.6081s13.2541,29.6038,29.6038,29.6038,29.6038-13.2541,29.6038-29.6038S46.0225.0043,29.6729.0043ZM29.6729,56.7397c-14.9844,0-27.1316-12.1472-27.1316-27.1315S14.6885,2.4765,29.6729,2.4765s27.1315,12.1472,27.1315,27.1316-12.1472,27.1315-27.1315,27.1315Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerSatisfactionNordyne);
export default __webpack_public_path__ + "static/media/customer-satisfaction-Nordyne.4583d0b7fab2457e3c32b0f5906d034c.svg";
export { ForwardRef as ReactComponent };